// extracted by mini-css-extract-plugin
export default {"note":"NotesFromProvider_note__SyJb6","title":"NotesFromProvider_title__TtBmH","value":"NotesFromProvider_value__cHiiT"};